<div class="wrapper">
	<div class="header">
		<div class="header__title">
			<span class="freud-icon freud-icon-mail"></span>
			<div class="text">
				{{
					'PROMPTUARY.TASK.TITLE'
						| translate
							: {
									name: name ? name : 'Usuário'
							  }
				}}
			</div>
		</div>
		<div class="header__subtitle">
			{{ 'PROMPTUARY.TASK.SUBTITLE' | translate }}
		</div>
		<div class="header__info">
			{{ 'PROMPTUARY.TASK.INFO' | translate }}
			<a id="know-more" (click)="openHelperModal()">{{
				'PROMPTUARY.TASK.KNOWN_MORE' | translate
			}}</a>
		</div>
	</div>

	<div class="inputs-wrapper zk-mt-4">
		<div class="zk-flex zk-flex-col">
			<label for="description">{{
				'PROMPTUARY.TASK.ORIENTATIONS' | translate
			}}</label>
			<textarea
				id="task-description"
				[formControl]="description"
				ngDefaultControl
				(ngModelChange)="saveTask()"
				[maxLength]="500"
				placeholder="{{
					'PROMPTUARY.TASK.ORIENTATIONS_PLACEHOLDER' | translate
				}}"
			></textarea>
			<div class="zk-flex zk-justify-end">
				<div class="char-counter">
					{{ description.value ? description.value?.length : 0 }}/ 500
				</div>
			</div>
		</div>
		<div>
			<label for="links">{{ 'PROMPTUARY.TASK.LINKS' | translate }}</label>
			<p class="zk-mb-1 links__description">
				{{ 'PROMPTUARY.TASK.LINKS_DESCRIPTION' | translate }}
			</p>
			<div class="zk-flex zk-gap-1">
				<freud-input-text
					class="zk-flex-1"
					id="new-link"
					[invalid]="isInvalidUrl"
					(keydown.enter)="
						$event.key === 'Enter' && newLink.length > 0 && addLink()
					"
					ngDefaultControl
					[(ngModel)]="newLink"
					[placeholder]="'PROMPTUARY.TASK.LINKS_PLACEHOLDER' | translate"
				></freud-input-text>
				<freud-button
					[disabled]="links.value.length === 3"
					(keydown.enter)="newLink.length > 0 && addLink()"
					id="add-link"
					(click)="addLink()"
					icon="freud-icon freud-icon-plus"
				></freud-button>
			</div>
		</div>
		<span *ngIf="isInvalidUrl" class="url__error">{{
			'PROMPTUARY.TASK.INVALID_URL' | translate
		}}</span>
		<div class="link__wraper zk-mt-1" *ngIf="showLinks">
			<div class="delete-loading__wrapper" *ngIf="linkLoading">
				<freud-loader></freud-loader>
			</div>
			<div class="link-tag" *ngFor="let link of links.value">
				<a [href]="link" target="_blank" noreferrer noopener>{{
					link.specifications.url
				}}</a>
				<span
					id="remove-link"
					(click)="removeLink(link.id)"
					(keydown.escape)="removeLink(link.id)"
					class="freud-icon freud-icon-times-circle"
					tabindex="0"
				></span>
			</div>
		</div>
		<div *ngIf="showAlert" class="inputs-wrapper__alert">
			<span class="freud-icon freud-icon-info-circle"></span>
			<div
				class="text"
				[innerHTML]="
					'PROMPTUARY.TASK.ALERT'
						| translate
							: {
									name: name ? name : 'Usuário'
							  }
				"
			></div>
		</div>
	</div>
</div>

<freud-dialog
	[draggable]="false"
	[modal]="true"
	[(visible)]="isHelperModalOpen"
	[header]="'PROMPTUARY.TASK.HOW_IT_WORKS' | translate"
>
	<div class="zk-flex zk-flex-col zk-items-center zk-gap-3">
		<p>{{ 'PROMPTUARY.TASK.HOW_IT_WORKS_DESCRIPTION' | translate }}</p>
		<img
			alt="task use example"
			lass="zk-mt-3"
			src="/assets/gif/gif_plano-de-acao.gif"
		/>
	</div>
</freud-dialog>
